{
  "page_Helseregistre_NavigateBackLinkTitle": "Dearvvašvuođaregistarii",
  "page_Samvalg_NavigateBackLinkTitle": "Ovttasválljen",
  "page_Samvalg_NavigateBackLinkURL": "{HelsenorgeUrl}/samvalg",
  "page_VelgBehandlingssted_NavigateBackLinkTitle": "Vállje dikšunbáikki",
  "page_Behandlinger_NavigateBackLinkTitle": "Divššut"
}
